module.exports = __webpack_public_path__ + "img/for-partners-banner.c2ef4633.jpg";